module.exports = __webpack_public_path__ + "img/powered-by.dc9653d9.svg";